export default function AnalyticsHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b59abe5345ba9b733ced8573d180f0db.jpg"
          alt="Сквозная аналитика"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A2B4C]/60 via-[#1A2B4C]/55 to-[#1A2B4C]/65"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 pt-28 pb-16 sm:pt-32 sm:pb-20 text-center">
        <div className="inline-flex items-center gap-2 bg-[#C5A880]/20 border border-[#C5A880]/40 rounded-full px-5 py-2 mb-8">
          <i className="ri-bar-chart-2-line text-[#C5A880] text-lg"></i>
          <span className="text-[#C5A880] text-sm font-semibold font-['Montserrat'] uppercase tracking-widest">Сквозная аналитика</span>
        </div>

        <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-['Playfair_Display'] font-bold text-white mb-6 sm:mb-8 leading-tight">
          Настройка сквозной аналитики «под ключ»: от клика до реальных денег в вашей кассе.
        </h1>

        <p className="text-base sm:text-xl md:text-2xl text-white/90 mb-10 sm:mb-14 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
          Индивидуальные решения под ваши бизнес-процессы. Узнайте, какой рекламный рубль приносит прибыль, а какой — исчезает бесследно.
        </p>

        <a
          href="#analytics-lead-form"
          className="group inline-flex items-center gap-2 bg-[#C5A880] hover:bg-[#B39770] text-white px-6 sm:px-12 py-4 sm:py-5 rounded-full text-sm sm:text-base md:text-lg font-bold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer font-['Montserrat'] text-center"
        >
          <i className="ri-arrow-right-line text-lg sm:text-xl flex-shrink-0"></i>
          <span>Получить план оцифровки бизнеса</span>
        </a>

        {/* Stats */}
        <div className="mt-12 sm:mt-20 grid grid-cols-3 gap-2 sm:gap-8 max-w-3xl mx-auto">
          {[
            { value: '2–5×', label: 'рост эффективности рекламы' },
            { value: '100%', label: 'прозрачность бюджета' },
            { value: '0 ₽', label: 'потерь на слепых каналах' },
          ].map((stat, i) => (
            <div key={i} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-2 py-3 sm:px-6 sm:py-6">
              <div className="text-lg sm:text-4xl font-bold text-[#C5A880] font-['Playfair_Display'] mb-1">{stat.value}</div>
              <div className="text-[10px] sm:text-sm text-white/80 font-['Montserrat'] leading-snug">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
